import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsViadeoComponent } from './simple-icons-viadeo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsViadeoComponent ],
    exports:      [ SimpleIconsViadeoComponent ],
    bootstrap:    []
})
export class SimpleIconsViadeoModule {}
